module.exports = {
    shortDuration: 0.5,
    slowDownDuration: 1.5,
    params: {
        mousewheel: {
            ratio: 0.006,
            inertiaRatio: 0.7
        },
        keyboard: {
            step: 0.1,
            pageStep: 1
        },
        touch: {
            ratio: 0.006,
            inertiaRatio: 1.6
        }
    }
};


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/ProjectScrollSettings.js